import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useStore } from "ra-core";

import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";

import { RevisorLargoPlazo } from "../datos/RevisorLargoPlazo";
import { CampanaAvisos } from "../equipo/CampanaAvisos";
import { GuiaHost } from "../guia/GuiaHost";
import { BuscadorFichas } from "../negocios/BuscadorFichas";
import { VentanaFicha } from "../negocios/VentanaFicha";
import { ANCHO_BARRA, ANCHO_BARRA_PLEGADA, BarraLateral } from "./BarraLateral";

/**
 * Layout de escritorio (≥ 768 px), FASE 2.5: barra lateral fija y plegable a la
 * izquierda y contenido a todo el ancho con márgenes razonables.
 */
export const LayoutEscritorio = ({ children }: { children: ReactNode }) => {
  const [plegada] = useStore<boolean>("nevora.barra.plegada", false);
  return (
    <>
      <RevisorLargoPlazo />
      <BarraLateral />
      {/* Campana de avisos arriba a la derecha, en la fila de los botones de cada pantalla, con
          el número de avisos sin leer encima (Robert, 09/10/2026). El contenido deja su hueco. */}
      <div className="fixed right-6 top-[30px] z-30">
        <CampanaAvisos plegada alinear="end" />
      </div>
      <main
        id="main-content"
        // overflow-x-clip: ninguna pantalla puede ensanchar la página; lo ancho (tablero, tablas) se
        // desplaza dentro de su propio recuadro (03/11/2026).
        className="min-h-screen overflow-x-clip py-5 pr-20 transition-[padding] duration-200"
        style={{
          paddingLeft: `calc(${plegada ? ANCHO_BARRA_PLEGADA : ANCHO_BARRA} + 1.5rem)`,
        }}
      >
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <BuscadorFichas />
      <VentanaFicha />
      <GuiaHost />
      <Notification />
    </>
  );
};
